<template>
  <section-row title="LP" :is-loading="anstalldStore.itp2.isLoading">
    <section-row
      v-for="kapital in anstalldStore.itp2.data?.lp?.kapital"
      :key="kapital.forsakringsbolagNamn"
      :title="kapital.forsakringsbolagNamn"
      :subTitle="kapital.subtext"
      :value="
        formattedAmountInCurrency(kapital.belopp)
          ? formattedAmountInCurrency(kapital.belopp)
          : '-'
      "
      :value-is-numeric="true"
    />
    <section-row title="Preliminärt belopp per månad (hittills uppsamlat)">
      <section-row
        v-for="preliminartBelopp in anstalldStore.itp2.data?.lp
          ?.preliminaraBelopp"
        :key="preliminartBelopp.title"
        :title="preliminartBelopp.title"
        :value="
          preliminartBelopp.beloppPerManad
            ? formattedAmountInCurrency(
                Math.floor(preliminartBelopp.beloppPerManad),
              )
            : '-'
        "
      />
    </section-row>
  </section-row>
</template>
<script lang="ts" setup>
import { SectionRow } from "@/components/sections";
import { formattedAmountInCurrency } from "@/common/formatters";

import { useAnstalldStore } from "../store";

const anstalldStore = useAnstalldStore();
</script>
